import { FormattedDebts, isDebtAvailableForPayment } from "@/utils/transform";
import useI18n from "@/hooks/useI18n";

const defaultFormatPlate = (plate: string) =>
  plate.replace(/^([A-Za-z]{3})(\d[A-Za-z]?\d{2,3})$/, "$1-$2");

interface DebtPassageCardProps {
  item: FormattedDebts;
  isSelected: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  formatPlate?: (plate: string) => string;
}

export default function DebtPassageCard({
  item,
  isSelected,
  onChange,
  formatPlate = defaultFormatPlate,
}: DebtPassageCardProps) {
  const { t } = useI18n();
  const isAvailable = isDebtAvailableForPayment(item);
  const formattedPlate = formatPlate(item.plate);

  if (!isAvailable) {
    return (
      <div
        className="bg-white rounded-[16px] p-5 flex border border-[#e5729b]"
        aria-disabled="true"
      >
        <div className="flex items-center w-full">
          <div className="flex-1 flex flex-col gap-1 opacity-30">
            <span className="inline-flex self-start px-1 rounded text-xs font-medium font-secondary tracking-[-0.4px] leading-[16.8px] bg-[#e6e6e6] text-[#696966]">
              {formattedPlate}
            </span>
            <p className="text-xs text-text font-secondary tracking-[-0.4px] leading-[16.8px]">
              {item.original?.nmConcessionaria || item.nmConcessionaria}
            </p>
          </div>
          <div className="flex flex-col gap-1 items-end text-right">
            <p className="text-xs font-bold font-secondary tracking-[-0.4px] leading-[16.8px] text-primary">
              {t("pages:home:paymentInProcessing")}
            </p>
            <p className="text-lg font-medium text-text font-secondary tracking-[-0.4px] leading-[21.6px] opacity-20">
              R$ {item.price}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <label
      className={`bg-white rounded-[16px] p-5 flex cursor-pointer transition-all ${
        isSelected ? "border border-[#e5729b]" : "border border-transparent"
      }`}
    >
      <input
        type="checkbox"
        name={item.id}
        className="sr-only"
        onChange={onChange}
        checked={isSelected}
      />
      <div className="flex items-center w-full">
        <div className="flex-1 flex flex-col gap-1">
          <span
            className={`inline-flex self-start px-1 rounded text-xs font-medium font-secondary tracking-[-0.4px] leading-[16.8px] ${
              isSelected ? "bg-primary text-white" : "bg-[#e6e6e6] text-[#696966]"
            }`}
          >
            {formattedPlate}
          </span>
          <p className="text-xs text-text font-secondary tracking-[-0.4px] leading-[16.8px]">
            {item.original?.nmConcessionaria || item.nmConcessionaria}
          </p>
        </div>
        <div className="flex flex-col gap-1 items-end text-right">
          {item.hasDate && (
            <p className="text-xs text-[#696966] font-secondary tracking-[-0.4px] leading-[16.8px]">
              {item.daysLeft > 0
                ? `Vencido há ${item.daysLeft} dia(s)`
                : `Vencimento ${item.dtVencimento?.substring(0, 5)}`}
            </p>
          )}
          <p className="text-lg font-medium text-text font-secondary tracking-[-0.4px] leading-[21.6px]">
            R$ {item.price}
          </p>
        </div>
      </div>
    </label>
  );
}
